<div *ngIf="showComponent==='CREATE'">
    <a (click)="showComponent = 'LIST'">&lt; List</a>
    <app-create-drill (saved)="searchDrills(); showComponent='LIST'"></app-create-drill>
</div>

<div *ngIf="showComponent==='LIST'">
    <button class="btn btn-green btn-full-width margin-top-large" (click)="showComponent='CREATE'">+ Add Drill</button>
    <div class="table-container">
    <table *ngIf="this.drills.length > 0">
        <thead>
        <tr>
            <th>Drill</th>
            <th>Club</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let d of drills">
            <td>{{ d.label }}</td>
            <td>{{ d.club_label }}</td>
        </tr>
        </tbody>
    </table>
    </div>
</div>

